import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=71cfbf26&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=71cfbf26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cfbf26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71cfbf26')) {
      api.createRecord('71cfbf26', component.options)
    } else {
      api.reload('71cfbf26', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=71cfbf26&scoped=true", function () {
      api.rerender('71cfbf26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderManagement/commissionBaseDeductionSetting/components/orderDetail.vue"
export default component.exports